import React, { useState, useEffect, useRef } from "react";
// import { Table } from "semantic-ui-react";
import { Accordion, ContainerHeader, WrapperInner, Container, ContainerSubtitle, Profile, HeaderContainer, ModuloContainer, CourseData, Box, InputTextArea, MainText, Input, ButtonReset, SemanticLoader, SendDocumentation } from "./styles";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import {  producaov2 } from "../../../../services/apis";
import Loading from "../../../Loading";
import { FaArrowAltCircleDown, FaArrowAltCircleUp, FaWindowClose, FaCheckSquare, FaRegClock } from "react-icons/fa";
import { smallDateFormat, smallDateFormatWithTime } from "../../../../utils/Utils";
import { TableContainer, TableHead, TableRow, Paper, TableCell, TableBody, Table } from '@material-ui/core';
import { organizarInformacoes } from "../../../../helpers/Dashboard";
import { useRouter } from "../../../../hooks/router";

const DashboardMBA = (req) => {
  const id = req.match.params.id;
  const [openIndex, setOpenIndex] = useState(null);
  const [openIndex2, setOpenIndex2] = useState(null);
  const [sendDocs, setSendDocs] = useState(false);
  const [incompany, setIncompany] = useState({
    incompany: [],
    old_incompany: []
  });

  const ref_pedidos = useRef(null);
  const ref_cursos = useRef(null);
  const ref_mba = useRef(null);
  const ref_company = useRef(null);
  // const ref_observacao = useRef(null);

  const [aluno, setAluno] = useState({});
  const [loading, setLoading] = useState(true);
  const router = useRouter();

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const handleToggle2 = (index) => {
    setOpenIndex2(openIndex2 === index ? null : index);
  };
  useEffect(() => {
    producaov2.get(`/admin/dashboard/pessoa/${id}`).then(res => {
      if (res.data) {
        setAluno(res.data);
        const dd = organizarInformacoes(res.data.incompany);
        setIncompany(dd);
        setSendDocs(!!res.data.mba[0]?.hasDocs);
        setLoading(false);
        if(router.query){
          const my_query = router.query;
          if(my_query?.mba){
            ref_mba.current.scrollIntoView();
            return;
          }
          if(my_query?.pedidos){
            ref_pedidos.current.scrollIntoView();
            return;
          }
          if(my_query?.cursos){
            ref_cursos.current.scrollIntoView();
            return;
          }
          if(my_query?.company){
            ref_company.current.scrollIntoView();
            return;
          }
        }
      }
    })
      .catch(error => console.log("Error", error))
  }, [])

  function createData(
    { curso,
      data_cadastro,
      id_curso,
      is_extended,
      observacao,
      valor_pago,
      pagamento,
      status,
      type,
      voucher }

  ) {
    return { curso, data_cadastro, id_curso, is_extended, observacao, valor_pago, pagamento, status, type, voucher };
  }

  async function handleDocumentation() {
    setSendDocs(!sendDocs);
    await producaov2.post("/mba/check-user-documents");
    return;

  }

  if (loading) {
    return (
      <Loading msg="Buscando dados..." />
    );
  }

  return (
    <div style={{ width: "100vw", paddingLeft: "250px" }}>
      <AdminMenu />
      <Container>
        <Profile>
          {aluno.pessoa?.foto && (<img src={aluno.pessoa?.foto} alt="pessoa" />)}
          <div className="wrapper">
            <WrapperInner>
              <p className="title-p">Dados Pessoais</p>
              <p><strong>Nome:</strong>{aluno?.pessoa?.nome || <span>Sem Registro</span>}</p>
              <p><strong>Email:</strong>{aluno?.pessoa?.email || <span>Sem Registro</span>}</p>
              <p><strong>CPF:</strong>{aluno?.pessoa?.cpf || <span>Sem Registro</span>}</p>
              <p><strong>Celular:</strong>{aluno?.pessoa?.celular || <span>Sem Registro</span>}</p>
              <p><strong>Nascimento:</strong>{smallDateFormat(aluno?.pessoa?.data_nascimento)}</p>
              <p><strong>Cadastro:</strong>{smallDateFormat(aluno?.pessoa?.data_cadastro)}</p>
            </WrapperInner>
            <WrapperInner>
              <p className="title-p">Dados de Endereço</p>
              <p><strong>Rua:</strong>{aluno?.pessoa?.endereco || <span>Sem Registro</span>}</p>
              <p><strong>Número:</strong>{aluno?.pessoa?.numero || <span>Sem Registro</span>}</p>
              <p><strong>Complemento:</strong>{aluno?.pessoa?.complemento || <span>Sem Registro</span>}</p>
              <p><strong>Bairro:</strong>{aluno?.pessoa?.bairro || <span>Sem Registro</span>}</p>
              <p><strong>Cidade:</strong>{aluno?.pessoa?.cidade || <span>Sem Registro</span>}</p>
              <p><strong>Estado:</strong>{aluno?.pessoa?.estado || <span>Sem Registro</span>}</p>
            </WrapperInner>
          </div>
        </Profile>
        {/* <h2>Dados absolutos:</h2>
        <ContainerHeader>
          <Box color="#444">
            <p>N.º de Cursos</p>
            <MainText isMinimal>{aluno.cursos.length}</MainText>
          </Box>
          <Box color="#444">
            <p>Faturamento</p>
            <MainText isMinimal>R${aluno.paid}</MainText>
          </Box>
          <Box color="#444">
            <p>Pedidos Concluidos</p>
            <MainText isMinimal>{aluno.status.pedido_concluido}</MainText>
          </Box>
          <Box color="#444">
            <p>Pedidos Pendentes</p>
            <MainText isMinimal>{aluno.status.pedido_pendente}</MainText>
          </Box>
          <Box color="#444">
            <p>Pedidos Estornados</p>
            <MainText isMinimal>{aluno.status.pedido_estorno}</MainText>
          </Box>
          <Box color="#444">
            <p>Certificados Gerados</p>
            <MainText isMinimal>{aluno.certificados_gerados}</MainText>
          </Box>
          <Box color="#444">
            <p>Cursos Concluidos</p>
            <MainText isMinimal>{aluno.status_curso.concluido}</MainText>
          </Box>
          <Box color="#444">
            <p>Cursos Em Andamento</p>
            <MainText isMinimal>{aluno.status_curso.em_andamento}</MainText>
          </Box>
          <Box color="#444">
            <p>Não Iniciados</p>
            <MainText isMinimal>{aluno.status_curso.nao_iniciado}</MainText>
          </Box>
          <Box color="#444">
            <p>VoittoCoins</p>
            <MainText isMinimal>{aluno.voittocoins}</MainText>
          </Box>
        </ContainerHeader> */}

        {/* <h2 ref={ref_observacao}>Observações:</h2>
        <Box color="#444" style={{
          width: "100%",
          height:"100%"
        }}>
          <InputTextArea/>
        </Box> */}



        {
          aluno?.pedidos.length ? (
            <>
              <h2 ref={ref_pedidos}>Pedidos:</h2>
              <ContainerSubtitle>
                <div style={{ background: "#f9cb9c" }}></div>
                <span>MBA</span>
                <div style={{ background: "#a4c2f4" }}></div>
                <span>Combos/Formação</span>
              </ContainerSubtitle>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                  <TableHead style={{ position: "sticky", top: 0 }}>
                    <TableRow style={{ textAlign: "left", backgroundColor: "#282828" }}>
                      <TableCell align="left">ID Curso</TableCell>
                      <TableCell align="left">Curso</TableCell>
                      <TableCell align="left">Data</TableCell>
                      <TableCell align="left">Valor</TableCell>
                      <TableCell align="left">Pagamento</TableCell>
                      <TableCell align="center">Status</TableCell>
                      <TableCell align="center">Observação</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      aluno.pedidos
                        .map(item => (createData(item)))
                        .map((row, index) => (
                          <TableRow
                            hover
                            key={index}
                            // component={Link}
                            // to={`/admin/dashboard/aluno/${row.id_pessoa}`}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                            style={{
                              background: row.type === "isMba" ? "#f9cb9c" : row.type === "isCombo" ? "#a4c2f4" : "#FFF"
                            }}
                          >
                            <TableCell scope="row" >
                              {row.id_curso}
                            </TableCell>
                            <TableCell >
                              {row.curso}
                            </TableCell>
                            <TableCell align="left">{row.data_cadastro ? smallDateFormat(row.data_cadastro) : "---"}</TableCell>
                            <TableCell align="left">R${row.valor_pago}</TableCell>
                            <TableCell align="left">{row.pagamento}</TableCell>
                            <TableCell align="center">{row.status === 3 ? <FaCheckSquare color="green" /> : [0, 1, 2].includes(row.status) ? "Aguardando Pagamento" : "--"}</TableCell>
                            <TableCell align="center">{row.observacao}</TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>

            </>
          ) : (<></>)
        }
        {
          aluno?.mba.length ? (
            <>
              <h2 ref={ref_mba}>Seção de MBAs:</h2>
              <p>Documentação: <SendDocumentation onClick={() => handleDocumentation()}>{sendDocs ? "Marcar como Não enviado" : "Marcar como Enviado"}</SendDocumentation></p>
              <Accordion>
                {
                  aluno.mba.map((elem, index) => {
                    return (
                      <>
                        <HeaderContainer onClick={() => handleToggle(index)} >
                          <p>{elem.description}</p>
                          <p>Data inserção: {smallDateFormat(elem.created_at)}</p>
                          <p>N.º cursos:{elem.total_courses}</p>
                          <p>Progresso: {elem.percentage.toFixed(2).replace(".", ",")}%</p>
                          <p>Carga Horária: {elem.carga_horaria}h</p>
                          {openIndex === index ? <FaArrowAltCircleUp size={22} /> : <FaArrowAltCircleDown size={22} />}
                        </HeaderContainer>
                        {openIndex === index &&
                          elem.modulos.map((item, index2) => {
                            return (
                              <>
                                <ModuloContainer onClick={() => handleToggle2(index2)}>
                                  <p>{item.modulo}</p>
                                  <p>Data Liberação: {smallDateFormat(item.data_liberacao)}</p>
                                  <p>N.º cursos: {item.cursos?.length}</p>
                                  <p>Progresso: {((item.cursos.filter(elem => elem.porcentagem == 100).length * 100) / item.cursos?.length).toFixed(2).replace(".", ",")}%</p>
                                  <p>Carga Horária: {item.carga_horaria}h</p>
                                  {openIndex2 === index2 ? <FaArrowAltCircleUp size={22} /> : <FaArrowAltCircleDown size={22} />}
                                </ModuloContainer>
                                {
                                  openIndex2 === index2 && item.cursos.map(dados => {
                                    return (
                                      <CourseData style={{ background: dados?.porcentagem >= 100 ? "#b6d7a8" : "#FFF" }}>
                                        <p>{dados.id_curso} - {dados.curso}</p>
                                        <p style={{ marginLeft: 'auto' }}>{dados.porcentagem.toFixed(2).replace(".", ",")}%</p>
                                        <p>{dados.carga_horaria}h</p>
                                      </CourseData>
                                    )
                                  })
                                }
                              </>
                            )
                          })
                        }
                      </>
                    )
                  })
                }
              </Accordion>
            </>
          ) : (<></>)
        }
        {
          aluno?.cursos.length ? (
            <>
              <h2 ref={ref_cursos}>Cursos:</h2>
              <TableContainer component={Paper} >
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                  <TableHead style={{ position: "sticky", top: 0 }}>
                    <TableRow style={{ textAlign: "left", backgroundColor: "#282828" }}>
                      <TableCell align="left">id_curso</TableCell>
                      <TableCell align="left">Curso</TableCell>
                      <TableCell align="left">Data Cadastro</TableCell>
                      <TableCell align="left">Validade</TableCell>
                      <TableCell align="center">Progresso</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {
                      aluno.cursos
                        .map((row, index) => (
                          <TableRow
                            hover
                            key={index}
                            // component={Link}
                            // to={`/admin/dashboard/aluno/${row.id_pessoa}`}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                            style={{
                              background: row?.progresso >= 100 ? "#b6d7a8" : "#FFF"
                            }}
                          >
                            <TableCell scope="row" >
                              {row.id_curso}
                            </TableCell>
                            <TableCell >
                              {row.curso}
                            </TableCell>
                            <TableCell align="left">{row.data_insert ? smallDateFormat(row.data_insert) : "---"}</TableCell>
                            <TableCell align="left">{smallDateFormat(row.validade)}</TableCell>
                            {/* <TableCell align="center">{row.status === 2 ? <FaCheckSquare color="green" /> : [0,1].includes(row.status) ? <FaRegClock color="#eead2d" /> : row.status === 3 ? "Não Iniciado" : <FaWindowClose color="red" />}</TableCell> */}
                            <TableCell align="center">{row?.progresso.toFixed(2).replace(".", ",") || 0}%</TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (<></>)
        }
                {
          incompany.incompany.length ? (<>
            <h2 ref={ref_company}>Para Empresas (Novo)</h2>
            {
              <TableContainer component={Paper} >
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                  <TableHead style={{ position: "sticky", top: 0 }}>
                    <TableRow style={{ textAlign: "left", backgroundColor: "#282828" }}>
                      <TableCell align="left">ID Company</TableCell>
                      <TableCell align="left">name</TableCell>
                      <TableCell align="left">status</TableCell>
                      <TableCell align="left">Data Cadastro</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {
                      incompany.incompany
                        .map((row, index) => (
                          <TableRow
                            hover
                            key={index}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <TableCell scope="row" >
                              {row.id_company}
                            </TableCell>
                            <TableCell >
                              {row.name}
                            </TableCell>
                            <TableCell align="left">{row.status === 1 ? <FaCheckSquare color="green" /> : row.status === 2 ? <FaWindowClose color="red" /> : <FaRegClock color="yellow" />}</TableCell>
                            <TableCell align="left">{row.created_at}</TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
            }

          </>) : (<></>)
        }
        {
          incompany.old_incompany.length ? (<>
            <h2 ref={ref_company}>Voitto Empresas (Antigo)</h2>
            {
              <TableContainer component={Paper} >
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                  <TableHead style={{ position: "sticky", top: 0 }}>
                    <TableRow style={{ textAlign: "left", backgroundColor: "#282828" }}>
                      <TableCell align="left">ID Company</TableCell>
                      <TableCell align="left">name</TableCell>
                      <TableCell align="left">status</TableCell>
                      <TableCell align="left">Data Cadastro</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {
                      incompany.old_incompany
                        .map((row, index) => (
                          <TableRow
                            hover
                            key={index}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <TableCell scope="row" >
                              {row.id_company}
                            </TableCell>
                            <TableCell >
                              {row.name}
                            </TableCell>
                            <TableCell align="left">{row.status !== "S" ? <FaWindowClose color="red" /> : <FaCheckSquare color="green" />}</TableCell>
                            <TableCell align="left">{row.type}</TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
            }

          </>) : (<></>)
        }
        {
          aluno?.acessos.length ? (
            <>
              <h2>Ultimas páginas Acessadas do Usuário:</h2>
              <TableContainer component={Paper} >
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                  <TableHead style={{ position: "sticky", top: 0 }}>
                    <TableRow style={{ textAlign: "left", backgroundColor: "#282828" }}>
                      <TableCell align="left">Url da Página</TableCell>
                      <TableCell align="left">Data</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {
                      aluno.acessos
                        .map((row, index) => (
                          <TableRow
                            hover
                            key={index}
                            // component={Link}
                            // to={`/admin/dashboard/aluno/${row.id_pessoa}`}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <TableCell scope="row" >
                              {row.url}
                            </TableCell>
                            <TableCell align="left">{row.last_access_at ? smallDateFormatWithTime(row.last_access_at) : "---"}</TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (<></>)
        }
        {
          aluno?.logs.length ? (
            <>
              <h2>Logs de Erro do Usuário:</h2>
              <TableContainer component={Paper} >
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                  <TableHead style={{ position: "sticky", top: 0 }}>
                    <TableRow style={{ textAlign: "left", backgroundColor: "#282828" }}>
                      <TableCell align="left">Url do Erro</TableCell>
                      <TableCell align="left">Description</TableCell>
                      <TableCell align="left">Registro</TableCell>
                      <TableCell align="left">Objeto do Erro</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {
                      aluno.logs
                        .map((row, index) => (
                          <TableRow
                            hover
                            key={index}
                            // component={Link}
                            // to={`/admin/dashboard/aluno/${row.id_pessoa}`}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <TableCell scope="row" >
                              {row.url}
                            </TableCell>
                            <TableCell >
                              {row.description}
                            </TableCell>
                            <TableCell align="left">{row.created_at ? smallDateFormat(row.created_at) : "---"}</TableCell>
                            <TableCell align="left">{row?.object?.message || JSON.stringify(row?.object)}</TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (<></>)
        }
      </Container>
    </div>
  );
};

export default DashboardMBA;
